export const openEntity = {
  category: 'open',
  code: null,
};

export const openEntityDialog = {
  open: false,
  ...openEntity,
};

export const presentationOptions = {
  BASIC: 'basic',
  CARDS: 'cards',
  TABLE: 'table',
};

export const CARDS_PAGE_SIZE = 69;

export const filterState = (minFilterLength = 0, requiresFilter = false) => ({
  filter: '',
  minFilterLength,
  requiresFilter,
});

export const visibilityFilters = (privateFlag = true, internalFlag = false, publicFlag = false) => ({
  privateFlag,
  internalFlag,
  publicFlag,
});

export const statusFilters = (
  pendingFlag = true,
  approvedFlag = false,
  deniedFlag = false,
  errorFlag = true,
) => ({
  pendingFlag,
  approvedFlag,
  deniedFlag,
  errorFlag,
});

export const paging = (pageSize = 20) => ({
  count: 0,
  currentPage: 1,
  pageSize,
  totalPages: 0,
});

export const pagingWithResults = (pageSize = 20) => ({
  ...paging(pageSize),
  results: [],
});

export const sortingFilters = (orderBy = [], singleSorting = true) => ({
  orderBy,
  singleSorting,
});

const pagingWithFilteredResults = (pageSize = 20, minFilterLength = 0, requiresFilter = false) => ({
  ...paging(pageSize),
  ...filterState(minFilterLength, requiresFilter),
  results: [],
});

export const activeState = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
};

export const entityVisibility = {
  PRIVATE: 'private',
  INTERNAL: 'internal',
};

export const entityCommonsVisibility = {
  ...entityVisibility,
  PUBLIC: 'public',
};

export const validityStatus = {
  VALID: 'valid',
  INVALID: 'invalid',
};

export default pagingWithFilteredResults;
